var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.management),function(item,i){return _c('li',{key:i,on:{"click":function($event){return _vm.RouteGo(item.name)}}},[_c('i',{class:[(_vm.icon = item.icon)]}),_c('span',[_vm._v(_vm._s(item.title))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e21d8cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonMenu/index.vue
// module id = null
// module chunks = 